import * as React from 'react';
import cn from 'classnames';

import { isMobile as isMobileQuery } from 'admin/utils/media-queries';
import t from 'common/utils/translate';
import { FONT_FILE_TYPES } from 'utils/assets';
import { getFontFileMetadata } from 'admin/utils/get-font-file-metadata';
import Text from 'admin/components/common/Text';
import { InitialState } from 'admin/components/pages/Settings/Fonts/AddFontsModal/reducer';

import css from './UploadCustomFontBtn.scss';

export type OnUploadParams = Pick<InitialState['uploadedFonts'], 'error' | 'items'>;

type Props = {
	className?: string;
	notAllowed: boolean;
	onFilesUpload: (params: OnUploadParams) => void;
};

export const UploadCustomFontBtn: React.FC<Props> = ({ notAllowed, onFilesUpload: onUpload, className = '' }) => {
	const isMobile = isMobileQuery();
	const onFilesUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
		const input = e.currentTarget;
		const files = Array.from(input.files ?? []);
		if (!files.length) return;

		try {
			if (files.some(file => !FONT_FILE_TYPES.includes(file.name.toLowerCase().split('.').pop() || 'unknown'))) {
				throw new Error('Wrong file type');
			}
			const results = await Promise.all(files.map(getFontFileMetadata));
			onUpload({ error: null, items: results });
		} catch (error) {
			const message = error instanceof globalThis.Error ? error.message : 'Failed to read font file.';
			onUpload({ error: { msg: message }, items: null });
		} finally {
			input.value = '';
		}
	};

	return (
		<div className={cn(css.uploadCustomFontBtn, className)}>
			<label htmlFor="upload">
				<input
					type="file"
					id="upload"
					multiple
					onChange={onFilesUpload}
					accept={FONT_FILE_TYPES.map(ext => `.${ext}`).join(',') || undefined}
					style={{ display: 'none' }}
				/>
				<button className={css.uploadBtn} type="button">
					<Text size={isMobile ? 'article' : 'subheading'} weight="semibold">
						{t('settings.pages.fonts.uploadFontBtnLabel')}
					</Text>
				</button>
			</label>
		</div>
	);
};
